import { useState } from "react";

type ToggleState = {
  show: boolean;
  autoFocus: boolean;
};

const useToggle = (initialShow?: boolean): [show: boolean, toggle: () => void, autoFocus: boolean] => {
  const [state, setState] = useState<ToggleState>({
    show: initialShow ?? false,
    autoFocus: false,
  });

  const toggle = (): void => {
    setState((prevState) => {
      const show = !prevState.show;
      return {
        show,
        autoFocus: show,
      };
    });
  };

  return [state.show, toggle, state.autoFocus];
};

export default useToggle;
